import * as React from 'react';

import { cn } from '@/lib/utils';
import { controlFocus } from '@/lib/controlStyles';

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentPropsWithoutRef<'textarea'>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      data-slot="textarea"
      className={cn(
        'tw:flex tw:field-sizing-content tw:min-h-16 tw:w-full tw:rounded-lg tw:border tw:border-input tw:bg-transparent tw:px-3 tw:py-2 tw:text-sm tw:text-foreground tw:shadow-xs tw:transition-[color,box-shadow] tw:placeholder:text-muted-foreground tw:hover:border-ring tw:disabled:opacity-50 tw:aria-invalid:border-destructive tw:aria-invalid:text-destructive tw:dark:aria-invalid:border-destructive/50',
        controlFocus,
        className
      )}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
